export default {
  button: {
    sendInfo: "Gửi thông tin",
  },
  message: {
    sendInfoSuccess: "Gửi thông tin thành công",
    sendInfoFail: "Gửi thông tin thất bại. Vui lòng thử lại",
    error: "Có lỗi xảy ra. Vui lòng thử lại",
    confirmRegisted: "Bạn muốn gửi duyệt hồ sơ?",
    send: "Gửi",
    registedSuccess: "Thông tin đăng ký dịch vụ của bạn đã được gửi đến",
    taxCodeIsRegisted: "MNS đã được đăng ký. Liên hệ NVKD JETPAY để được hỗ trợ",
    misaJetPay: "MISA JETPAY",
  },
  lable: {
    CCCDFront: "CCCD/CC mặt trước",
    CCCDBack: "CCCD/CC mặt sau",
    CMNDFront: "CMND mặt trước",
    CMNDBack: "CMND mặt sau",
    Passport: "Hộ chiếu",
    schoolEstablishmentProfile: "Quyết định thành lập trường",
  },
  detail: {
    pleaeImportImageFrom: "Vui lòng chụp ảnh từ",
    imageDes: "rõ nét, không mất góc, đầy đủ nội dung",
    original: "bản chính",
    docsCopy: "bản sao công chứng",
    acceptFileUpload: "định dạng *jpg, *.jpeg, *.png hoặc *.pdf",
    acceptFileUploadIdentity: "định dạng *jpg, *.jpeg hoặc *.png",
    cropImgDes: "cắt ảnh theo hướng dẫn bên dưới",
    schoolEstablishmentReplace:
      "Quyết định thành lập trường có thể thay thế bằng Giấy cấp con dấu/Giấy cấp mã quan hệ ngân sách/Giấy thay đổi tên trường/Giấy xác nhận của Đơn vị chủ quản...",
  },
  tooltip: {
    createContract: `Nếu chọn thì JETPAY tự động tạo và gửi mail hợp đồng cho nhà trường ký ngay sau khi thực hiện "Gửi thông tin"`,
  },
};
